import { Injectable} from '@angular/core'
import { HttpClient} from '@angular/common/http';
import { ehsCBAPI } from '../../../environments/environment'
import { SubTopic } from '../types/sub-topic.type';

@Injectable()

export class SubTopicService {

  constructor(private http: HttpClient) { }

  getSubTopics() {
    return this.http.get<SubTopic[]>(ehsCBAPI.endpoint + '/sub-topic');
  }

  getSubTopic(subTopicName) {
    return this.http.get<SubTopic>(ehsCBAPI.endpoint + '/sub-topic/' + subTopicName);
  }

  getSubTopicsByTopicId(topicId) {
    return this.http.get<SubTopic[]>(ehsCBAPI.endpoint + '/sub-topic?topicId=' + topicId);
  }

  postSubTopic(topic) {
    return this.http.post<SubTopic>(ehsCBAPI.endpoint + '/sub-topic', topic);
  }

  deleteSubTopic(topicId) {
    return this.http.delete<string>(ehsCBAPI.endpoint + '/sub-topic?subTopicId=' + topicId);
  }
}
